var _defs, _path, _circle, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgIcebergAnimal10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 272.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00cdda;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg-iceberg-animal10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.56,226.74c-1-8.13-2.08-16.23-4.7-24.05-4.47-13.33-13.15-21.81-27.28-24.32-8.16-1.45-16.3-.91-24.49-.59-20.08.8-40.06,2.62-60,4.76-19.19,2.07-38.27,4.9-57.31,8-14.23,2.32-28.46,4.83-43,3.22-17.23-1.91-25.69-8.94-30.06-22.69-2.51-7.92-3.74-15.93-1.48-24.17.61-2.2,1.67-3.53,4.1-3.88a52.38,52.38,0,0,0,7.08-1.78c16.25-4.94,25.79-17.18,25.69-33,0-1,.47-2.42-.7-2.92s-1.58.88-2.31,1.45c-3.85,3-7.83,5.8-13,3.61-7.32-3.08-13.9-1.8-20,3-1.1.87-2.21,1.71-3.63,2.81-.51-4.46-1.37-8.3-4.66-10.93-5.31-4.23-11.15-6.33-18-4-1.94.66-3.89,1.28-5.85,1.89a17,17,0,0,1-14.83-2c-1-.63-2-1.29-2.88-2C.64,97.89,0,98.35,0,100.23a86.26,86.26,0,0,0,.57,12.85c2.36,16,12.48,26.93,28.17,30.05,1.93.39,2.75,1,2.42,3.24a136.2,136.2,0,0,0-1.43,28.83c1.75,24.73,10.81,46.5,25.59,66.14C61.22,249.17,68.21,256,75,263c3.42,3.56,3.17,4.54-.89,7.47-2.77,2-5.86,3.58-8.24,6-2.15,2.22-1.76,4.31,1.06,5.53a20.49,20.49,0,0,0,5,1.45c6.7,1,13.42.33,20.11-.24,4.51-.38,8.91-1.6,13.56-.18,7,2.15,14.14,3.72,21.22,5.56,19.19,5,38.6,8.76,58.42,10,18.11,1.15,36.26,1,54.4.54a110.64,110.64,0,0,0,18.06-1.47c18-3.45,31-13,37.87-30.36,2.28-5.77,3.3-11.81,4.41-17.84V229C299.85,228.27,299.66,227.51,299.56,226.74ZM245,233.39a9.29,9.29,0,1,1,9.28-9.28A9.28,9.28,0,0,1,245,233.39Z",
    transform: "translate(0 -26.6)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1",
    className: "cls-1",
    cx: 285.08,
    cy: 83.14,
    r: 6.07
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1-2",
    "data-name": "Oval-1",
    className: "cls-1",
    cx: 272.85,
    cy: 46.25,
    r: 4.05
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1-3",
    "data-name": "Oval-1",
    className: "cls-1",
    cx: 295.48,
    cy: 22.59,
    r: 4.05
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1-4",
    "data-name": "Oval-1",
    className: "cls-1",
    cx: 279.02,
    cy: 3.03,
    r: 3.03
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1-5",
    "data-name": "Oval-1",
    className: "cls-1",
    cx: 258.19,
    cy: 106.98,
    r: 5.06
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgIcebergAnimal10);
export default __webpack_public_path__ + "static/media/bg-iceberg-animal10.8b6bc77ed5aa89ce6793d1a371a3e7b3.svg";
export { ForwardRef as ReactComponent };